import { axiosYtApiV2 } from "@/services/axios-yt-api-v2.js";

const axiosComplaint = {
  addComplaint(tourId, data) {
    return axiosYtApiV2.post(`complaint/${tourId}/add`, data);
  },
  uploadPhoto(data) {
    return axiosYtApiV2.post(`complaint/upload-photo`, data);
  },

}


export { axiosComplaint };
